import { withActions } from '@/modules/shared/hocs/withActions'
import { withGroups } from './withGroups'
import Reports, {
  ReportsStateProps,
  ReportsDispatchProps,
  ReportsOwnProps,
} from '../../components/administration/reports'

import type { Moment } from 'moment'
import { showMessage } from '@/modules/shared/stores/messageStore'
import * as React from 'react'
import { withUsers } from './withUsers'
import { withCompanyLists } from './withCompanyLists'
import {
  getCompaniesSimple,
  getCompaniesSimpleForGroups,
} from 'app/actions/company'
import { OutputType } from 'app/constants/outputType'
import {
  getActiveDriversReport,
  getAuditReport,
  getCompanyDataReport,
  getRealIncomeReport,
  getSynchronizationReport,
} from 'app/actions/printout'
import { setExported } from 'app/actions/driverActiveness'
import { MessageModel } from 'app/models/messageModel'

export function mapDispatchToProps(): Omit<
  ReportsDispatchProps,
  'getAvailableUsers' | 'getGroups'
> {
  return {
    showMessage: (message: MessageModel) => showMessage(message),
    getCompaniesBasic: (
      tenantId: string,
      includeDeleted: boolean = false,
      includeChildren: boolean = false,
    ) => getCompaniesSimple(tenantId, includeDeleted, includeChildren),
    getCompaniesBasicForGroups: (
      ids: Array<string>,
      includeDeleted: boolean = false,
    ) => getCompaniesSimpleForGroups(ids, includeDeleted),
    getRealIncomeReport: (companies: Array<string>, period: Moment) =>
      getRealIncomeReport(companies, period),
    getActiveDriversReport: (
      companies: Array<string>,
      groups: Array<string>,
      months: Array<number>,
      year: number,
      outputType: OutputType = OutputType.Pdf,
      showDetails: boolean,
      showActiveness: boolean,
      showTimesheet: boolean,
      showBusinessTrip: boolean,
      showPrintout: boolean,
      showBasic: boolean,
      showPRO: boolean,
      showVPN: boolean,
      showUpdater: boolean,
      showCurrentlyActive: boolean,
    ) =>
      getActiveDriversReport(
        companies,
        groups,
        months,
        year,
        outputType,
        showDetails,
        showActiveness,
        showTimesheet,
        showBusinessTrip,
        showPrintout,
        showBasic,
        showPRO,
        showVPN,
        showUpdater,
        showCurrentlyActive,
      ),
    getAuditReport: (
      companies: Array<string>,
      groups: Array<string>,
      user: string,
      startDate: Moment,
      endDate: Moment,
      events: Array<string>,
      outputType: OutputType = OutputType.Pdf,
      sortBy: number,
    ) =>
      getAuditReport(
        companies,
        groups,
        user,
        startDate,
        endDate,
        events,
        outputType,
        sortBy,
      ),
    getSynchronizationReport: (
      companies: Array<string>,
      user: string,
      startDate: Moment,
      endDate: Moment,
      outputType: OutputType = OutputType.Pdf,
      sortBy: number,
      onlyUpdater: boolean,
    ) =>
      getSynchronizationReport(
        companies,
        user,
        startDate,
        endDate,
        outputType,
        sortBy,
        onlyUpdater,
      ),
    setExported: () => setExported(),
    getCompanyDataReport: (
      companies: Array<string>,
      groups: Array<string>,
      months: Array<number>,
      year,
      outputType: OutputType = OutputType.Pdf,
      sortBy: number,
      onlyPro: boolean,
      onlyPackage: boolean,
      mergeSameCompanies: boolean,
      source: number,
      updatePaymentDate: boolean,
    ) =>
      getCompanyDataReport(
        companies,
        groups,
        months,
        year,
        outputType,
        sortBy,
        onlyPro,
        onlyPackage,
        mergeSameCompanies,
        source,
        updatePaymentDate,
      ),
  }
}

export default withGroups(
  withUsers(
    withCompanyLists(
      withActions(Reports as any, mapDispatchToProps()),
      'both',
    ) as any,
    { listProp: 'users', fetchProp: 'getAvailableUsers' },
  ) as any,
) as unknown as React.ComponentClass<ReportsOwnProps>
